// 加载echarts，注意引入文件的路径
import echarts from "echarts/lib/echarts";

// 再引入你需要使用的图表类型，标题，提示信息等
import "echarts/lib/chart/map";
import "echarts/map/js/china";
import "echarts/lib/chart/bar";
import "echarts/lib/chart/line";

export default echarts;
